import { Component, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {
  IonicPage,
  NavController,
  NavParams,
  AlertController,
  LoadingController,
  Platform
} from "ionic-angular";
import { RequestServiceProvider } from "../../providers/request-service/request-service";
import { File } from "@ionic-native/file";
import { TransactionAlertProvider } from "../../providers/transaction-alert/transaction-alert";
import { Camera, CameraOptions } from "@ionic-native/camera";
import { CONFIG } from "../../config/config";
import { ScannerProvider } from "../../providers/scanner/scanner";

declare var cordova: any;

/**
 * Generated class for the AgentPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: "page-agent",
  templateUrl: "agent.html"
})
export class AgentPage {
  @ViewChild("agentRegSlider") agentRegSlider: any;

  slideOneForm: FormGroup;
  slideTwoForm: FormGroup;
  slideThreeForm: FormGroup;
  submitAttempt: boolean = false;
  loader;
  addressImage: any;
  addressPath: any;
  photoImage: any;
  photoPath: any;
  idPath: any;
  idImage: any;
  states: Array<Object>;
  cities: Array<Object>;
  banks = [];
  public bankObj;
  public accountNumber;
  public bvn;
  public validateBvn = false;
  public preview = {};
  public terms = true;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public formBuilder: FormBuilder,
    private request: RequestServiceProvider,
    private alertCtrl: AlertController,
    private loading: LoadingController,
    private platform: Platform,
    private alert: TransactionAlertProvider,
    private camera: Camera,
    private scanner: ScannerProvider
  ) {
    this.slideOneForm = this.formBuilder.group({
      fullName: ["", Validators.required],
      phoneNumber: [
        "",
        Validators.compose([
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required
        ])
      ],
      businessName: ["", Validators.required],
      bankName: ["", Validators.required],
      bankAccount: [
        "",
        Validators.compose([
          Validators.minLength(10),
          Validators.maxLength(10),
          Validators.required
        ])
      ],
      bvn: [
        "",
        Validators.compose([
          Validators.minLength(11),
          Validators.maxLength(11),
          Validators.required
        ])
      ],
      email: [
        "",
        [
          Validators.required,
          Validators.pattern(
            "^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$"
          )
        ]
      ]
    });
    this.slideTwoForm = this.formBuilder.group({
      employmentType: ["", Validators.required],
      agentType: [""],
      identification: ["", Validators.required],
      state: ["", Validators.required],
      city: ["", Validators.required],
      address: ["", Validators.required]
    });
    this.slideThreeForm = this.formBuilder.group({
      addressPath: ["", Validators.required],
      photoPath: ["", Validators.required],
      idPath: ["", Validators.required]
    });
  }
  // end of contructor

  next() {
    this.agentRegSlider.slideNext();
  }

  prev() {
    this.agentRegSlider.slidePrev();
  }

  presentLoading(content) {
    this.loader = this.loading.create({
      content: content
    });
    this.loader.present();
  }

  getLga(state) {
    this.cities = state.lga;
  }

  termsAndConditions() {
    this.terms = !this.terms;
  }

  agentPhotoSelfie() {
    const options: CameraOptions = {
      quality: 30,
      destinationType: this.camera.DestinationType.DATA_URL,
      encodingType: this.camera.EncodingType.JPEG,
      mediaType: this.camera.MediaType.PICTURE,
      cameraDirection: this.camera.Direction.FRONT,
      correctOrientation: true
    };

    this.camera.getPicture(options).then(
      imageData => {
        // imageData is either a base64 encoded string or a file URI
        // If it's base64 (DATA_URL):
        this.photoImage = "data:image/jpeg;base64," + imageData;
      },
      err => {
        // Handle error
      }
    );
  }

  addressScan() {
    const file = new File();
    const configuration = {
      source: 'camera',
      jpegQuality: 20
    }
    cordova.plugins.GeniusScan.setLicenceKey(
      CONFIG.scannerKey,
      (response) => {
        console.log("initialized", response)
      },
      (error) => {
        console.log("initialized",error)
      }
    )
    cordova.plugins.GeniusScan.scanWithConfiguration(configuration, 
    async (result) => {
        const [processed] = result.scans
        const {enhancedUrl} = processed;
        const filename = enhancedUrl.substring(enhancedUrl.lastIndexOf("/") + 1);
        const path = enhancedUrl.substring(0, enhancedUrl.lastIndexOf("/") + 1);
        this.presentLoading("uploading...");
        this.addressPath = `${path}${filename}`;
        this.addressImage = await file.readAsDataURL(path, filename);
        this.loader.dismiss().catch(() => {});
    }, 
    (error) => {
      this.alert.presentNormalErrorAlert("Failed to upload, Try again");
    }
    )
  }

  idVerifyScan() {
    const file = new File();
    const configuration = {
      source: "camera",
      jpegQuality: 20
    };
    cordova.plugins.GeniusScan.setLicenceKey(
      CONFIG.scannerKey,
      response => {
        console.log("initialized", response);
      },
      error => {
        console.log("initialized", error);
      }
    );
    cordova.plugins.GeniusScan.scanWithConfiguration(
      configuration,
      async result => {
        const [processed] = result.scans;
        const { enhancedUrl } = processed;
        const filename = enhancedUrl.substring(
          enhancedUrl.lastIndexOf("/") + 1
        );
        const path = enhancedUrl.substring(0, enhancedUrl.lastIndexOf("/") + 1);
        this.presentLoading("uploading...");
        this.idPath = `${path}${filename}`;
        this.idImage = await file.readAsDataURL(path, filename);
        this.loader.dismiss().catch(() => {});
      },
      error => {
        this.alert.presentNormalErrorAlert("Failed to upload, Try again");
      }
    );
  }

  useGeniusScan() {
    const file = new File();
    const configuration = {
      source: "camera",
      jpegQuality: 20
    };
    cordova.plugins.GeniusScan.setLicenceKey(
      CONFIG.scannerKey,
      response => {
        console.log("initialized", response);
      },
      error => {
        console.log("initialized", error);
      }
    );
    cordova.plugins.GeniusScan.scanWithConfiguration(
      configuration,
      async result => {
        const [processed] = result.scans;
        const { enhancedUrl } = processed;
        const filename = enhancedUrl.substring(
          enhancedUrl.lastIndexOf("/") + 1
        );
        const path = enhancedUrl.substring(0, enhancedUrl.lastIndexOf("/") + 1);
        this.presentLoading("uploading...");
        this.idPath = `${path}${filename}`;
        this.idImage = await file.readAsDataURL(path, filename);
        this.loader.dismiss().catch(() => {});
      },
      error => {
        console.log(error);
      }
    );
  }

  selectedBank(bankName) {
    const bank = this.banks.find(
      bank => bank.name.toLowerCase() === bankName.toLowerCase()
    );
    return bank.cbn;
  }

  bvnValidation(accountNumber, bankCode, bvn) {
    this.presentLoading("verifying BVN...");
    this.request
      .postNameEnquiry({ accountNumber, bankCode })
      .subscribe(response => {
        this.loader.dismiss().catch(() => {});
        // return response.json().code
        if (response.json().code == "00") {
          console.log(bvn, response.json().bvn);
          if (bvn === response.json().bvn) {
            this.validateBvn = true;
          }
        }
        error => {
          this.loader.dismiss().catch(() => {});
          this.validateBvn = false;
          this.alert.presentNormalErrorAlert(error.massage);
          if (error.json().code == 403) {
            this.request.logout();
          }
        };
      });
  }

  //logic for the slides
  // slide count start from 0
  async goToSlideTwo() {
    this.submitAttempt = true;

    if (this.slideOneForm.valid) {
      const { bankAccount, bvn, bankName } = this.slideOneForm.value;
      const bankCode = this.selectedBank(bankName);
      const accountNumber = bankAccount;

      this.presentLoading("verifying BVN...");
      this.request
        .postNameEnquiry({ accountNumber, bankCode })
        .subscribe((response: any) => {
          this.loader.dismiss().catch(() => {});
          // return response.json().code
          if (response.json().code === "00") {
            console.log(bvn, response.json().bvn);
            if (bvn === response.json().bvn) {
              this.agentRegSlider.slideTo(2);
            } else {
              this.alert.presentNormalErrorAlert(
                "Incorrect BVN Or Account Number"
              );
              this.agentRegSlider.slideTo(1);
            }
          } else {
            this.alert.presentNormalErrorAlert(response.json().desc);
          }
          error => {
            this.loader.dismiss().catch(() => {});
            this.validateBvn = false;
            this.alert.presentNormalErrorAlert(error.massage);
            if (error.json().code == 403) {
              this.request.logout();
            }
          };
        });
    }
  }
  goToSlideThree() {
    // this.preview = Object.assign({},this.slideOneForm.value,this.slideTwoForm.value)
    this.submitAttempt = true;
    if (this.slideTwoForm.valid) {
      this.agentRegSlider.slideTo(3);
    } else {
      this.agentRegSlider.slideTo(2);
    }
  }

  goToSlideFour() {
    this.submitAttempt = true;
    this.preview = Object.assign(
      {},
      this.slideOneForm.value,
      this.slideTwoForm.value
    );
    if (this.slideThreeForm.valid && this.terms) {
      this.agentRegSlider.slideTo(4);
    } else {
      this.agentRegSlider.slideTo(3);
    }
  }

  generateArray(obj) {
    return Object.keys(obj).map(key => {
      return { key: key, value: obj[key] };
    });
  }

  readTerms() {
    window.open("http://google.com", "_system", "location=yes");
  }

  /* checkFocus(event) {
    this.validateBvn = false;
  } */

  save() {
    this.submitAttempt = true;

    if (!this.slideOneForm.valid) {
      this.agentRegSlider.slideTo(1);
    } else if (!this.slideTwoForm.valid) {
      this.agentRegSlider.slideTo(2);
    } /* else if(!this.slideThreeForm.valid){
        this.agentRegSlider.slideTo(3);
      } */ else {
      let data = Object.assign(
        {},
        this.slideOneForm.value,
        this.slideTwoForm.value,
        {
          addressVerify: this.addressImage,
          agentPhoto: this.photoImage,
          idVerify: this.idImage,
          agentCode: window.localStorage.getItem("agentCode")
        }
      );

      this.presentLoading("submitting...");

      this.request.postAgentRegistration(data).subscribe(
        data => {
          this.loader.dismiss().catch(() => {});
          if (data.status == 200) {
            this.alert.presentNormalSuccessAlert(
              "Your registration has been successfully submitted. You should receive an SMS with your login details in <strong>48hrs</strong> after we have reviewed your documents .Thanks for choosing ReadyCash"
            );
          }
        },
        error => {
          this.loader.dismiss().catch(() => {});
          this.alert.presentNormalErrorAlert("Registration Failed");
        }
      );
      // this.navCtrl.setRoot(RegistrationCompletePage,{title:'Congratulations!', message:'Registration Successful'});
    }
  }

  camelCaseToWords(camelCase) {
    return camelCase
      .replace(/([A-Z])/g, match => ` ${match}`)
      .replace(/^./, match => match.toUpperCase());
  }

  ionViewWillLoad() {
    //get sites and states
    this.request.getStatesAndCities().subscribe(
      data => {
        this.states = data;
      },
      error => {
        if (error.code === 403) {
          this.request.logout();
        }
      }
    );

    //get bank list
    this.request.getBankList().subscribe(
      data => {
        this.banks = data;
      },
      error => {
        if (error.json().code === 403) {
          this.request.logout();
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/agent/agent.ts